import { DashboardHeader } from '@modules/admin/Admin.Header'
import { Loading } from '@modules/core/components/Loading'
import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'
import AdministratorForm from './Admin.Form'
class UpdateAdministrator extends Component {
  administratorClient = Consultations.administrators

  state = {
    administrator: undefined,
    isFetching: false,
  }

  componentDidMount() {
    const administratorId = this.props.match.params.id
    this.setState({ isFetching: true })
    this.administratorClient
      .show(administratorId)
      .then((res) => {
        this.setState({ administrator: res.data, isFetching: false })
      })
      .catch((err) => {
        this.setState({ administrator: undefined, isFetching: false })
        window.alert(JSON.stringify(err.message, null, 2))
      })
  }

  render() {
    return (
      <div className="crud-wrapper administrator-wrapper">
        <div className="administrator-update">
          <DashboardHeader title={<Trans>Editar Administrator</Trans>}>
            <Link className="btn btn-primary" to={`/administrator`}>
              <Trans>Volver</Trans>
            </Link>
          </DashboardHeader>

          <Loading isFetching={this.state.isFetching} />
          <div className="container-fluid main-content">
            {this.state.administrator && <AdministratorForm initialValues={this.state.administrator} />}
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(UpdateAdministrator)
